export const API_GET_ALL_EMERGENCY_REASON = 'API_GET_ALL_EMERGENCY_REASON'
export const API_GET_ALL_EMERGENCY_REASON_SUCCESS = 'API_GET_ALL_EMERGENCY_REASON_SUCCESS'
export const API_GET_ALL_EMERGENCY_REASON_FAIL = 'API_GET_ALL_EMERGENCY_REASON_FAIL'

export const API_ADMIN_GET_ALL_EMERGENCY_REASON = 'API_ADMIN_GET_ALL_EMERGENCY_REASON'
export const API_ADMIN_GET_ALL_EMERGENCY_REASON_SUCCESS = 'API_ADMIN_GET_ALL_EMERGENCY_REASON_SUCCESS'
export const API_ADMIN_GET_ALL_EMERGENCY_REASON_FAIL = 'API_ADMIN_GET_ALL_EMERGENCY_REASON_FAIL'

export const API_ADMIN_GET_EMERGENCY_REASON = 'API_ADMIN_GET_EMERGENCY_REASON'
export const API_ADMIN_GET_EMERGENCY_REASON_SUCCESS = 'API_ADMIN_GET_EMERGENCY_REASON_SUCCESS'
export const API_ADMIN_GET_EMERGENCY_REASON_FAIL = 'API_ADMIN_GET_EMERGENCY_REASON_FAIL'

export const API_ADMIN_POST_EMERGENCY_REASON = 'API_ADMIN_POST_EMERGENCY_REASON';
export const API_ADMIN_POST_EMERGENCY_REASON_SUCCESS = 'API_ADMIN_POST_EMERGENCY_REASON_SUCCESS';
export const API_ADMIN_POST_EMERGENCY_REASON_FAIL = 'API_ADMIN_POST_EMERGENCY_REASON_FAIL';

export const API_ADMIN_PATCH_EMERGENCY_REASON = 'API_ADMIN_PATCH_EMERGENCY_REASON';
export const API_ADMIN_PATCH_EMERGENCY_REASON_SUCCESS = 'API_ADMIN_PATCH_EMERGENCY_REASON_SUCCESS';
export const API_ADMIN_PATCH_EMERGENCY_REASON_FAIL = 'API_ADMIN_PATCH_EMERGENCY_REASON_FAIL';

export const API_ADMIN_DELETE_EMERGENCY_REASON = 'API_ADMIN_DELETE_EMERGENCY_REASON';
export const API_ADMIN_DELETE_EMERGENCY_REASON_SUCCESS = 'API_ADMIN_DELETE_EMERGENCY_REASON_SUCCESS';
export const API_ADMIN_DELETE_EMERGENCY_REASON_FAIL = 'API_ADMIN_DELETE_EMERGENCY_REASON_FAIL';

export const ADMIN_INIT_NEW_EMERGENCY_REASON = 'ADMIN_INIT_NEW_EMERGENCY_REASON'

export const ADMIN_RESET_FOCUS_EMERGENCY_REASON = 'ADMIN_RESET_FOCUS_EMERGENCY_REASON'